module.exports = __webpack_public_path__ + "static/img/logo-blue.ca2d7001.png";